import React from "react";
import { useTheme } from "../../hooks";
import { ActionCardThemeType } from "../../types";
import { Icon } from "../icon";
import { Actions, Container } from "./ActionCardStyles";

type ActionCardProps = {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onDelete?: (event: React.MouseEvent<HTMLElement>) => void;
  onEdit?: (event: React.MouseEvent<HTMLElement>) => void;
  styles?: ActionCardThemeType;
};

const ActionCard: React.FC<React.PropsWithChildren<ActionCardProps>> = ({
  children,
  onClick,
  onDelete,
  onEdit,
  styles = {},
}) => {
  const { Theme } = useTheme();
  const StylesOverride: ActionCardThemeType = { ...Theme.actionCard, ...styles };
  return (
    <Container onClick={onClick} styles={StylesOverride}>
      <Actions>
        {!!onEdit && (
          <Icon
            iconName="fa-pencil"
            onClick={onEdit}
            styles={{
              size: "0.875rem",
            }}
          />
        )}
        {!!onDelete && (
          <Icon
            className="ms-2"
            iconName="fa-trash-alt"
            onClick={onDelete}
            styles={{
              size: "0.875rem",
            }}
          />
        )}
      </Actions>
      <div>{children}</div>
    </Container>
  );
};

export default ActionCard;
